module.exports = __webpack_public_path__ + "img/icon_coupon_active.31f84abd.png";